import * as React from 'react';
import env from 'src/shared/env';
import './ECheckTableDesktop.scss';
import ECheckRowDesktop from '../ECheckRowDesktop';
import EmptyPayments from '../EmptyPayments';
import ECheckPaymentDetailDesktop from '../ECheckPaymentDetailDesktop';
import EcheckVoidModal from '../EcheckVoidModal';

interface IECheckTableDesktopProps {
  payments: any[];
  handleSortedValEcheck(sortVal: string): void;
  desc: string;
  asc: string;
  sortColnameEcheck: string;
}

interface IECheckTableDesktopState {
  showPaymentDetails: boolean;
  selectedPayment: any;
  paymentIdToVoid: number;
  showVoidModal: boolean;
}

class ECheckTableDesktop extends React.Component<
  IECheckTableDesktopProps,
  IECheckTableDesktopState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      showPaymentDetails: false,
      selectedPayment: null,
      paymentIdToVoid: null,
      showVoidModal: false
    };
  }

  private handleCloseModal = () => {
    this.setState({
      showPaymentDetails: false
    });
  };

  private handlePaymentDetails = (e: any, payment: any) => {
    e.preventDefault();

    this.setState({
      selectedPayment: payment,
      showPaymentDetails: true
    });
  };

  private voidECheck = (paymentId: number) => {
    this.setState({ paymentIdToVoid: paymentId, showVoidModal: true });
  };

  private handleCloseVoidModal = () => {
    this.setState({ showVoidModal: false });
  };

  private handleChangeCheckbox = (echeck: any) => {
    if (!echeck.taker) {
      this.voidECheck(echeck.databaseId);
    }
  };
  // customer code change
  public setOrderColumnEcheck = (colname: any) => {
    this.props.handleSortedValEcheck(colname);
  };

  public render() {
    return (
      <div className="rp-echeck-table-desktop">
        {this.props.payments.length === 0 ? (
          <EmptyPayments />
        ) : (
          <div className="row rp-echeck-table-header">
            <div className="col-3 rp-echeck-table-desktop-col">
              <h4>Payment id</h4>
            </div>
            {env.REACT_APP_BASE_ENVIRONMENT !== 'CA' ? (
              <>
                <div
                  // className="col-2 rp-echeck-table-desktop-col"
                  className={`col-2 rp-echeck-table-desktop-col sortable ${
                    this.props.sortColnameEcheck === 'paymentDate'
                      ? 'selected'
                      : ''
                  }`}
                  onClick={() => {
                    this.setOrderColumnEcheck('paymentDate');
                  }}
                >
                  <p>Pmt Date</p>
                  <div className="table-header-order">
                    <i className={`rpds-arrow-drop-up ${this.props.asc}`} />
                    <i className={`rpds-arrow-drop-down ${this.props.desc}`} />
                  </div>
                </div>
                <div
                  // className="col-1 rp-echeck-table-desktop-col"
                  className={`col-1 rp-echeck-table-desktop-col sortable ${
                    this.props.sortColnameEcheck === 'userId' ? 'selected' : ''
                  }`}
                  onClick={() => {
                    this.setOrderColumnEcheck('userId');
                  }}
                >
                  <p>Cust code</p>
                  <div className="table-header-order">
                    <i className={`rpds-arrow-drop-up ${this.props.asc}`} />
                    <i className={`rpds-arrow-drop-down ${this.props.desc}`} />
                  </div>
                </div>
              </>
            ) : (
              <>
                <div
                  // className="col-2 rp-echeck-table-desktop-col"
                  className={`col-2 rp-echeck-table-desktop-col sortable `}
                >
                  <p>Pmt Date</p>
                </div>
                <div
                  // className="col-1 rp-echeck-table-desktop-col"
                  className={`col-1 rp-echeck-table-desktop-col `}
                >
                  <p>Cust code</p>
                </div>
              </>
            )}

            <div className="col-2 rp-echeck-table-desktop-col">
              <h4>status</h4>
            </div>
            <div className="col-2 rp-echeck-table-desktop-col">
              <h4>Pmt amount</h4>
            </div>
            <div className="col-2 rp-echeck-table-desktop-col">
              <h4>Actions</h4>
            </div>
          </div>
        )}
        {this.props.payments.map(payment => (
          <ECheckRowDesktop
            key={payment.paymentNumber}
            payment={payment}
            onShowDetails={this.handlePaymentDetails}
            onChangeCheckbox={this.handleChangeCheckbox}
          />
        ))}
        {this.state.showPaymentDetails && this.state.selectedPayment && (
          <ECheckPaymentDetailDesktop
            onCloseModal={this.handleCloseModal}
            paymentDetails={this.state.selectedPayment}
          />
        )}
        {this.state.showVoidModal && this.state.paymentIdToVoid && (
          <EcheckVoidModal
            handleCloseModal={this.handleCloseVoidModal}
            paymentId={this.state.paymentIdToVoid}
          />
        )}
      </div>
    );
  }
}

export default ECheckTableDesktop;
